import script from "./AdvScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvScreen.vue?vue&type=script&setup=true&lang=js"

import "./AdvScreen.vue?vue&type=style&index=0&id=04adb0dc&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04adb0dc"]])

export default __exports__